import { render, staticRenderFns } from "./WaitingForApprovalPage.vue?vue&type=template&id=d116efec&scoped=true"
import script from "./WaitingForApprovalPage.vue?vue&type=script&lang=js"
export * from "./WaitingForApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./WaitingForApprovalPage.vue?vue&type=style&index=0&id=d116efec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d116efec",
  null
  
)

export default component.exports